"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WebGLShaderProgram_1 = require("./WebGLShaderProgram");
const Shader_1 = require("../../tree/Shader");
class WebGLShader extends Shader_1.Shader {
    constructor(context) {
        super(context);
        this.vertexShaderSource = undefined;
        this.fragmentShaderSource = undefined;
        this._initialized = false;
        const stage = context.stage;
        this.gl = stage.gl;
        let program = stage.renderer.getShaderProgram(this.getConstructor());
        if (!program) {
            program = new WebGLShaderProgram_1.WebGLShaderProgram(this.gl, this.constructor.prototype.vertexShaderSource, this.constructor.prototype.fragmentShaderSource);
            // Let the vbo context perform garbage collection.
            stage.renderer.setShaderProgram(this.getConstructor(), program);
        }
        this._program = program;
    }
    getConstructor() {
        return this.constructor;
    }
    get glProgram() {
        return this._program.glProgram;
    }
    _init() {
        if (!this._initialized) {
            this.initialize();
            this._initialized = true;
        }
    }
    initialize() {
        this._program.compile();
    }
    get initialized() {
        return this._initialized;
    }
    _uniform(name) {
        return this._program.getUniformLocation(name);
    }
    _attrib(name) {
        return this._program.getAttribLocation(name);
    }
    _setUniform(name, value, glFunction) {
        this._program.setUniformValue(name, value, glFunction);
    }
    useProgram() {
        this._init();
        this.gl.useProgram(this.glProgram);
        this.beforeUsage();
        this.enableAttribs();
    }
    stopProgram() {
        this.afterUsage();
        this.disableAttribs();
    }
    hasSameProgram(other) {
        // For performance reasons, we first check for identical references.
        return other && (other === this || other._program === this._program);
    }
    beforeUsage() {
        // Override to set settings other than the default settings (blend mode etc).
    }
    afterUsage() {
        // All settings changed in beforeUsage should be reset here.
    }
    enableAttribs() {
        // Noop
    }
    disableAttribs() {
        // Noop
    }
    getExtraAttribBytesPerVertex() {
        return 0;
    }
    getVertexAttribPointerOffset(operation) {
        return operation.extraAttribsDataByteOffset - (operation.index + 1) * 4 * this.getExtraAttribBytesPerVertex();
    }
    setExtraAttribsInBuffer(operation) {
        // Set extra attrib data in in operation.quads.data/floats/uints, starting from
        // operation.extraAttribsBufferByteOffset.
    }
    setupUniforms(operation) {
        // Set all shader-specific uniforms.
        // Notice that all uniforms should be set, even if they have not been changed within this shader instance.
        // The uniforms are shared by all shaders that have the same type (and shader program).
    }
    _getProjection(operation) {
        return operation.getProjection();
    }
    getFlipY(operation) {
        return this._getProjection(operation)[1] < 0;
    }
    beforeDraw(operation) {
        // Noop
    }
    draw(operation) {
        // Noop
    }
    afterDraw(operation) {
        // Noop
    }
    cleanup() {
        this._initialized = false;
        // Program takes little resources, so it is only destroyed when the full stage is destroyed.
    }
}
exports.WebGLShader = WebGLShader;
//# sourceMappingURL=WebGLShader.js.map